export const faqList = [
  {
    question: '男同网是什么样的平台？',
    answer: '男同网是专为男同群体打造的综合性线上平台，提供交友互动、社群交流、生活资讯、权益支持和健康科普等服务。我们致力于为每一位社群成员创造一个安全、包容、多元的网络空间，让大家能够在这里找到归属感、获得有用的信息，并与志同道合的人建立真诚的连接。',
  },
  {
    question: '在平台上交友是否安全？如何保护个人隐私？',
    answer: '我们非常重视用户的隐私和安全。建议您在交友过程中注意以下几点：不轻易透露个人敏感信息（如身份证号、家庭住址等）；首次见面选择公共场所；告知朋友您的去向；使用平台内通讯工具而非直接交换私人联系方式直到建立充分信任。我们会持续优化平台的隐私保护机制。',
  },
  {
    question: '如何参与社群活动和线上讨论？',
    answer: '您可以关注我们的活动资讯栏目，了解最新的线上和线下活动信息。线上讨论会定期在社群群组中举办，您可以通过活动页面报名参与。线下活动会提前公布时间、地点和报名方式，欢迎根据自己的情况选择参加。',
  },
  {
    question: '平台上的健康资讯可靠吗？',
    answer: '我们健康专栏的内容由专业的医疗顾问团队审核，参考了权威的医学指南和公共卫生机构的建议。但请注意，平台内容仅供参考，不能替代专业医疗诊断。如有具体健康问题，请务必咨询正规医疗机构的医生。',
  },
  {
    question: '我可以为平台投稿分享自己的故事吗？',
    answer: '当然可以！我们非常欢迎社群成员分享自己的真实故事和经历。您可以通过关于我们页面的联系表单提交投稿意向，我们的编辑团队会与您联系。所有投稿都会经过匿名化处理以保护您的隐私，您也可以选择使用笔名发表。',
  },
  {
    question: '如何获取法律援助和心理支持？',
    answer: '您可以在权益支持栏目找到相关的法律知识和维权指南。如需紧急心理支持，请拨打全国心理援助热线400-161-9995。我们也整理了各地LGBT友好心理咨询机构和法律援助组织的联系方式，可以在相关文章中查看。',
  },
  {
    question: '平台是否免费？需要付费会员吗？',
    answer: '男同网目前完全免费，所有内容和服务均面向所有用户开放。我们暂时没有付费会员计划，未来如有变化会提前公告。我们的使命是为男同社群提供支持和连接，而非盈利。',
  },
];

export const features = [
  {
    title: '安全私密',
    description: '严格的数据保护机制，多重隐私设置，让你安心交流和分享。你的隐私安全是我们最重视的基石。',
    icon: 'ri-lock-line',
  },
  {
    title: '真实社群',
    description: '汇聚来自全国各地的真实男同朋友，真诚交流，建立有意义的人际连接和深厚友谊。',
    icon: 'ri-group-line',
  },
  {
    title: '专业资讯',
    description: '由专业人士编写和审核的健康、法律、心理资讯，为你提供可靠的知识支持和实用指南。',
    icon: 'ri-article-line',
  },
  {
    title: '温暖包容',
    description: '无论你的背景、年龄、身份如何，这里都欢迎你。我们相信多元就是力量，包容让社区更美好。',
    icon: 'ri-sun-line',
  },
  {
    title: '权益守护',
    description: '法律知识科普、维权指导、社群互助，我们坚定地站在每一位社群成员身后提供支持。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '活动丰富',
    description: '线上线下多样化的社群活动，从读书会到户外徒步，总有一款适合你的兴趣和社交需求。',
    icon: 'ri-calendar-2-line',
  },
];

export const reviews = [
  {
    id: 1,
    name: '小杰',
    location: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20with%20friendly%20smile%2C%20casual%20style%2C%20warm%20portrait%2C%20simple%20neutral%20background&width=120&height=120&seq=review-avatar-1&orientation=squarish',
    text: '在男同网上认识了很多志同道合的朋友，这种找到归属感的感觉真的很好。平台的内容也很丰富，特别是健康专栏对我帮助很大。',
    rating: 5,
  },
  {
    id: 2,
    name: '阿明',
    location: '成都',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%2030s%20with%20gentle%20smile%2C%20warm%20portrait%20photography%2C%20simple%20background%2C%20approachable%20look&width=120&height=120&seq=review-avatar-2&orientation=squarish',
    text: '作为一个刚出柜不久的人，这里的故事专栏给了我很多勇气和力量。看到那么多人和我有相似的经历，让我觉得自己并不孤单。',
    rating: 5,
  },
  {
    id: 3,
    name: 'Leo',
    location: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20man%20with%20stylish%20glasses%2C%20confident%20expression%2C%20urban%20professional%20portrait%2C%20simple%20background&width=120&height=120&seq=review-avatar-3&orientation=squarish',
    text: '权益支持板块的法律知识特别实用。之前在工作中遇到了一些困扰，通过平台了解到了自己的合法权益和维权途径。',
    rating: 5,
  },
  {
    id: 4,
    name: '晨晨',
    location: '深圳',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20with%20bright%20smile%2C%20energetic%20and%20positive%20portrait%2C%20simple%20clean%20background%2C%20warm%20lighting&width=120&height=120&seq=review-avatar-4&orientation=squarish',
    text: '线上社群活动的氛围特别好，每次参与都能收获新的见解和朋友。希望平台越办越好，为更多人提供这样一个温暖的空间。',
    rating: 5,
  },
];

export const stats = [
  { value: '50,000+', label: '社群成员' },
  { value: '600+', label: '优质文章' },
  { value: '98%', label: '用户好评率' },
  { value: '30+', label: '覆盖城市' },
];